import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import AddButton from './AddButton';
import CancelButton from './CancelButton';
import LabelledSwitch from './LabelledSwitch';
import PrimaryButton from './PrimaryButton';
import { globalStyles as styles } from './style/gstheme';
import TitledPanel from './TitledPanel';

class GetBooleanValueDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: props.open,
            checked: false,
            error: false
        };
    }

    handleClickOpen = () => { this.setState({ open: true }); };

    addLiteral = () => {
        this.setState({ open: false });
        this.props.onAddLiteral(this.state.checked.toString(), "http://www.w3.org/2001/XMLSchema#boolean");
        this.setState({ checked: false });
    };

    exitAddLiteral = () => this.setState({ open: false, checked: false });

    handleChange = (checked) => this.setState({ checked });

    render() {

        const { checked } = this.state;
        const { classes, icon, disabled } = this.props;

        return (
            <React.Fragment>
                <AddButton disabled={disabled} icon={icon} dataTest="add-boolean" title="Add a boolean value" onClick={this.handleClickOpen} />
                <Dialog
                    data-test="boolean-dialog"
                    className={classes.dialog}
                    open={this.state.open && !disabled}
                    onClose={this.exitAddLiteral} aria-labelledby="createboolean-dialog-title">
                    <DialogTitle disableTypography className={classes.mainHeading} id="createboolean-dialog-title">Add Boolen Value</DialogTitle>
                    <DialogContent style={{ width: '300px' }}>
                        <TitledPanel title="Select Value">
                            <div style={{ display: 'flex' }}>
                                <Typography className={classes.formLabel} style={{ marginTop: 18 }}>False</Typography>
                                <LabelledSwitch
                                    dataTest="true-false"
                                    label="True"
                                    checked={checked}
                                    handleChange={this.handleChange}
                                />
                            </div>
                        </TitledPanel>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddLiteral} />
                        <PrimaryButton onClick={this.addLiteral}>Add</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

GetBooleanValueDialog.defaultProps = {
    disabled: false,
    open: false
};

GetBooleanValueDialog.propTypes = {
    icon: PropTypes.object,
    disabled: PropTypes.bool,
    open: PropTypes.bool,
    onAddLiteral: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(GetBooleanValueDialog);
